// src/components/Layout.js
import React, { useState, useEffect } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";

const Layout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  return (
    <div className="app-shell">
      <Header
        onToggleTheme={() => setTheme(t => (t === "light" ? "dark" : "light"))}
        theme={theme}
      />
      <div className="main-area">
        <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(c => !c)} />
        <div className="content-area">{children}</div>
      </div>
    </div>
  );
};

export default Layout;
